import React from "react";
import { 
  HashRouter, 
  Redirect,
  Route, 
  Switch 
} from "react-router-dom";
import * as jwt_decode from 'jwt-decode';

// components
import Layout from "./Layout";
import LayoutClient from "./Layout/Client/LayoutClient";
import LayoutSales from "./Layout/Sales/LayoutSales";

// pages
import Error from "../pages/error";
import Login from "../pages/login";

// context
import { useUserState } from "../context/UserContext";

function checkToken(){
  try
  {
    const token = localStorage.getItem('id_token');
    if(token)
    {
      const decoded = jwt_decode(token);
      if(decoded && decoded.role)
      {
        localStorage.setItem('role', decoded.role);
        return localStorage.getItem("role");
      }
    }
    return "";
  }
  catch
  {
    return "";
  }
}

export default function App() {
  // global
  var { isAuthenticated } = useUserState();
  const userType = checkToken();
  var isAdm = userType === "ADMIN" ? true : false;
  var isClient = userType === "CLIENT" ? true : false;
  var isSales = userType === "SALES" ? true : false;
  if(isAdm === true)
  {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
          
          <AdminRoute path="/dashboard" component={LayoutClient} />
          <AdminRoute path="/pushNotifications" component={LayoutClient} />
          <AdminRoute path="/receivedPayments" component={LayoutClient} />           
          <AdminRoute path="/reportPayments" component={Layout} /> 
          <AdminRoute path="/reportByPublisher" component={Layout} />
          <AdminRoute path="/indicatorsByPublisher" component={Layout} />
          <AdminRoute path="/placementsByPublisher" component={Layout} />
          <AdminRoute path="/layoutTypes" component={Layout} />
          <AdminRoute path="/layoutDefinition" component={Layout} />
          <AdminRoute path="/publisherSettings" component={Layout} />
          <AdminRoute path="/sites" component={Layout} />
          <AdminRoute path="/users" component={Layout} />
          <AdminRoute path="/networks" component={Layout} />
          <AdminRoute path="/blackList" component={Layout} />
          <AdminRoute path="/adunits" component={Layout} />
          <AdminRoute path="/analyticsIntegration" component={Layout} />
          
          <PublicRoute path="/login" component={Login} />
          <Route component={Error} />
          
        </Switch>
      </HashRouter>
    );
  } 
  else
  if(isClient === true)
  {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
          
          <ClientRoute path="/dashboard" component={LayoutClient} />
          <ClientRoute path="/pushNotifications" component={LayoutClient} />
          <ClientRoute path="/receivedPayments" component={LayoutClient} /> 
          {/* <ClientRoute path="/analyticsIntegration" component={LayoutClient} />  */}
          
          <PublicRoute path="/login" component={Login} />
          <Route component={Error} />
          
        </Switch>
      </HashRouter>
    );
  } 
  else 
  if(isSales === true)
  {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
          
          <SalesRoute path="/dashboard" component={LayoutSales} />
          <SalesRoute path="/reportByPublisher" component={LayoutSales} />
          
          <PublicRoute path="/login" component={Login} />
          <Route component={Error} />
          
        </Switch>
      </HashRouter>
    );
  }
  else{
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/login" />} />
          <PublicRoute path="/login" component={Login} />
          <Route component={Error} />          
        </Switch>
      </HashRouter>
    );
  }


  // #######################################################################

  function AdminRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated && isAdm ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function ClientRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated && (isClient || isAdm) ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function SalesRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated && (isSales || isAdm) ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
